<form [formGroup]="form" (submit)="submit()">
  <div class="dialog">
    <div class="dialog-title">
      <h4 i18n>Skapa anställningsavtal</h4>
    </div>

    <div mat-dialog-content class="dialog-content">
      <sut-stepper [linear]="false" #stepper class="py-4">
        <sut-step label="Språk" i18n-label [stepControl]="formGroups.language">
          <div class="p-4 bg-white">
            <p i18n>Med den här guiden skapar du ett anställningsavtal.</p>
            <p i18n>När det är klart kan du skicka avtalet för e-signering eller ladda ned det som pdf.</p>
            <div class="mt-10">
              <mat-form-field class="w-64" appearance="fill">
                <mat-label i18n>Språk för avtalet</mat-label>
                <mat-select [formControl]="formControls.language" required>
                  <mat-option i18n [value]="Language.Swedish">Svenska</mat-option>
                  <mat-option i18n [value]="Language.English">Engelska</mat-option>
                  <mat-option i18n [value]="Language.Both">Svenska och Engelska</mat-option>
                </mat-select>
                <mat-error *ngIf="formControls.language.hasError('required')" i18n>Måste väljas</mat-error>
              </mat-form-field>
            </div>
          </div>
        </sut-step>

        <sut-step label="Person" i18n-label [stepControl]="formGroups.employee">
          <div class="flex flex-col p-4 bg-white">
            <div>
              <mat-form-field style="min-width: 350px" appearance="fill">
                <mat-label i18n>Vem ska anställas</mat-label>
                <app-object-input [formControl]="formControls.employee" required />
                <button mat-button type="button" color="primary" matSuffix (click)="selectEmployee()">
                  <span *ngIf="formControls.employee.value" i18n>BYT PERSON</span>
                  <span *ngIf="!formControls.employee.value" i18n>VÄLJ PERSON</span>
                </button>
                <mat-error *ngIf="formControls.employee.hasError('required')" i18n>Måste väljas</mat-error>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field style="min-width: 350px" appearance="fill">
                <mat-label i18n>Adress</mat-label>
                <input
                  matInput
                  [formControl]="formControls.employeeAddress"
                  placeholder="Adress (Adress, postnummer, ort)"
                  i18n-placeholder
                  required
                />
                <mat-hint i18n>(Adress, postnummer, ort)</mat-hint>
                <mat-error *ngIf="formControls.employeeAddress.hasError('required')" i18n>Måste fyllas i</mat-error>
              </mat-form-field>
            </div>
          </div>
        </sut-step>

        <sut-step label="Företaget" i18n-label [stepControl]="formGroups.signatory">
          <div class="flex flex-col p-4 bg-white">
            <div>
              <mat-form-field style="min-width: 350px" appearance="fill">
                <mat-label i18n>Företagets adress</mat-label>
                <input
                  matInput
                  [formControl]="formControls.companyAddress"
                  placeholder="Adress (Adress, postnummer, ort)"
                  i18n-placeholder
                  required
                />
                <mat-hint i18n>(Adress, postnummer, ort)</mat-hint>
                <mat-error *ngIf="formControls.companyAddress.hasError('required')" i18n>Måste fyllas i</mat-error>
              </mat-form-field>
            </div>
          </div>
        </sut-step>

        <sut-step label="Anställning" i18n-label [stepControl]="formGroups.employment">
          <div class="p-4 bg-white flex flex-col gap-10">
            <div class="flex flex-row gap-10">
              <div class="flex flex-col w-52">
                <mat-form-field class="w-52" appearance="fill">
                  <mat-label i18n>Anställningsform</mat-label>
                  <mat-select [formControl]="formControls.kind" required>
                    <mat-option [value]="EmploymentKind.Indefinite" i18n>Tillsvidare</mat-option>
                    <mat-option [value]="EmploymentKind.Limited" i18n>Särskild visstidsanställning</mat-option>
                    <mat-option [value]="EmploymentKind.Hourly" i18n>Timanställning</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-checkbox
                  *ngIf="
                    data.docKind !== DocKind.ManagingDirector && formControls.kind.value === EmploymentKind.Indefinite
                  "
                  [formControl]="formControls.probationary"
                  color="primary"
                  i18n
                  >Provanställning</mat-checkbox
                >
                <div class="w-52 text-sm" *ngIf="formControls.probationary.value" i18n>
                  Avtalas/meddelas inget annat övergår en provanställning i en tillsvidareanställning på samma villkor
                  när den löper ut.
                </div>
              </div>
              <div *ngIf="data.docKind !== DocKind.ManagingDirector && formControls.probationary.value" class="w-52">
                <mat-form-field appearance="fill">
                  <mat-label i18n>Provanställingen varar i</mat-label>
                  <input
                    matInput
                    [formControl]="formControls.probationaryPeriod"
                    [integerOnly]="true"
                    [minNumber]="1"
                    [maxNumber]="6"
                    required
                  />
                  <mat-error *ngIf="formControls.hoursPerWeek.hasError('required')" i18n>Måste fyllas i</mat-error>
                  <mat-error *ngIf="formControls.hoursPerWeek.hasError('minNumber')" i18n>Minst 1 månad</mat-error>
                  <mat-error *ngIf="formControls.hoursPerWeek.hasError('maxNumber')" i18n>Högst 6 månader</mat-error>
                  <span matSuffix i18n>månader</span>
                </mat-form-field>
                <div class="flex flex-row flex-grow gap-2 w-64">
                  <div class="self-center">{{ sliderProbPeriod.min }}</div>
                  <mat-slider
                    #sliderProbPeriod
                    class="flex flex-row w-64"
                    color="primary"
                    thumbLabel
                    step="1"
                    min="1"
                    max="6"
                    aria-label="units"
                    ><input matSliderThumb [formControl]="formControls.probationaryPeriod"
                  /></mat-slider>
                  <div class="self-center">{{ sliderProbPeriod.max }}</div>
                </div>
              </div>
            </div>

            <div class="flex flex-row gap-10">
              <mat-form-field class="w-52" appearance="fill">
                <mat-label i18n>Omfattning</mat-label>
                <mat-select [formControl]="formControls.partTime" required>
                  <mat-option [value]="false" i18n>Heltid</mat-option>
                  <mat-option [value]="true" i18n>Deltid</mat-option>
                </mat-select>
              </mat-form-field>

              <ng-container
                *ngIf="formControls.partTime.value && formControls.kind.value === EmploymentKind.Hourly"
                class="w-52"
              >
                <mat-checkbox
                  [formControl]="formControls.workingTimeNotSpecified"
                  class="self-center"
                  color="primary"
                  i18n
                >
                  Timmar ej specificerade
                </mat-checkbox>
              </ng-container>

              <mat-form-field
                *ngIf="formControls.partTime.value && !formControls.workingTimeNotSpecified.value"
                class="w-52"
                appearance="fill"
              >
                <mat-label i18n>Timmar per vecka</mat-label>
                <input
                  matInput
                  [formControl]="formControls.hoursPerWeek"
                  [integerOnly]="true"
                  [minNumber]="1"
                  [maxNumber]="40"
                  required
                />
                <mat-error *ngIf="formControls.hoursPerWeek.hasError('required')" i18n>Måste fyllas i</mat-error>
                <mat-error *ngIf="formControls.hoursPerWeek.hasError('minNumber')" i18n
                  >Minst 1 timme i veckan</mat-error
                >
                <mat-error *ngIf="formControls.hoursPerWeek.hasError('maxNumber')" i18n
                  >Högst 40 timmar i veckan</mat-error
                >
                <mat-hint i18n>Upp till 40 timmar är valbart</mat-hint>
              </mat-form-field>
            </div>

            <div class="flex flex-row gap-10">
              <mat-form-field
                *ngIf="formControls.kind.value === EmploymentKind.Limited; else notimeLimit"
                class="flex flex-row w-96"
                appearance="fill"
              >
                <mat-label i18n>Anställningsperiod</mat-label>
                <mat-date-range-input [formGroup]="formGroups.employment" [rangePicker]="campaignOnePicker">
                  <input matStartDate placeholder="Startdatum" [formControl]="formControls.startDate" required />
                  <input matEndDate placeholder="Slutdatum" [formControl]="formControls.endDate" required />
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="campaignOnePicker" />
                <mat-date-range-picker #campaignOnePicker />

                <ng-container *ngIf="(formControls.startDate.statusChanges | async) === 'INVALID'">
                  <mat-error *ngIf="formControls.startDate.hasError('required')" i18n
                    >Måste fylla i startdatum</mat-error
                  >
                </ng-container>
                <ng-container *ngIf="(formControls.endDate.statusChanges | async) === 'INVALID'">
                  <mat-error *ngIf="formControls.endDate.hasError('required')" i18n>Måste fylla i slutdatum</mat-error>
                </ng-container>
              </mat-form-field>

              <ng-template #notimeLimit>
                <mat-form-field class="flex flex-row w-52" appearance="fill">
                  <mat-label i18n>Anställningens startdatum</mat-label>
                  <input matInput [matDatepicker]="picker" [formControl]="formControls.startDate" required />
                  <mat-datepicker-toggle matSuffix [for]="picker" />
                  <mat-datepicker #picker />
                  <mat-error *ngIf="formControls.startDate.hasError('required')" i18n
                    >Måste fylla i startdatum</mat-error
                  >
                </mat-form-field>
              </ng-template>
            </div>

            <div class="flex flex-col gap-3">
              <div *ngIf="formControls.kind.value === EmploymentKind.Limited">
                <mat-checkbox [formControl]="formControls.hasNoticePeriod" color="primary" i18n
                  >Uppsägningstid</mat-checkbox
                >
                <div class="text-sm w-[350px]" i18n>
                  Det är vanligt att tidsbegränsade anställningar under 6 månader inte är uppsägningsbara. De löper då
                  på tills den avtalade tiden går ut. Det är trots det möjligt att reglera uppsägningstiden. Anges
                  anställningstid under 3 månader med uppsägningstid är uppsägningstiden 1 månad.
                </div>
              </div>
              <div
                *ngIf="formControls.hasNoticePeriod.value && (maxNoticePeriod$ | async) > 1"
                class="flex flex-row gap-4"
              >
                <div>
                  <mat-form-field class="flex flex-row flex-grow w-[350px]" appearance="fill">
                    <mat-label>
                      <ng-container *ngIf="data.docKind !== DocKind.ManagingDirector" i18n>Uppsägningstid</ng-container>
                      <ng-container *ngIf="data.docKind === DocKind.ManagingDirector" i18n
                        >Uppsägningstid från den anställdes sida</ng-container
                      >
                    </mat-label>
                    <input
                      matInput
                      [formControl]="formControls.noticePeriodEmployee"
                      [integerOnly]="true"
                      [maxNumber]="maxNoticePeriod$ | async"
                      [minNumber]="1"
                      required
                    />
                    <span matSuffix i18n>{formControls.noticePeriodEmployee.value, plural,
                      ='1' {månad}
                      other {månader}
                    }</span>
                  </mat-form-field>
                  <div class="flex flex-row flex-grow gap-2 w-[350px]">
                    <div class="self-center">{{ sliderNoticePeriod.min }}</div>
                    <mat-slider
                      #sliderNoticePeriod
                      class="flex flex-row w-[350px]"
                      color="primary"
                      thumbLabel
                      step="1"
                      min="1"
                      [max]="maxNoticePeriod$ | async"
                      aria-label="units"
                      ><input matSliderThumb [formControl]="formControls.noticePeriodEmployee"
                    /></mat-slider>
                    <div class="self-center">{{ sliderNoticePeriod.max }}</div>
                  </div>
                </div>
                <div *ngIf="data.docKind === DocKind.ManagingDirector">
                  <mat-form-field class="flex flex-row flex-grow w-96" appearance="fill">
                    <mat-label i18n>Uppsägningstid från arbetsgivarens sida</mat-label>
                    <input
                      matInput
                      [formControl]="formControls.noticePeriodEmployer"
                      [integerOnly]="true"
                      [maxNumber]="maxNoticePeriod$ | async"
                      [minNumber]="1"
                      required
                    />
                    <span matSuffix i18n>{formControls.noticePeriodEmployer.value, plural,
                      ='1' {månad}
                      other {månader}
                    }</span>
                  </mat-form-field>
                  <div class="flex flex-row flex-grow gap-2 w-96">
                    <div class="self-center">{{ sliderNoticePeriod.min }}</div>
                    <mat-slider
                      #sliderNoticePeriod
                      class="flex flex-row w-96"
                      color="primary"
                      thumbLabel
                      step="1"
                      min="1"
                      [max]="maxNoticePeriod$ | async"
                      aria-label="units"
                      ><input matSliderThumb [formControl]="formControls.noticePeriodEmployer"
                    /></mat-slider>
                    <div class="self-center">{{ sliderNoticePeriod.max }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="flex flex-col gap-3">
              <div class="flex flex-row gap-4">
                <div>
                  <mat-form-field class="flex flex-row flex-grow w-52" appearance="fill">
                    <mat-label i18n>Ordinarie arbetstid startar</mat-label>
                    <input
                      matInput
                      type="time"
                      [formControl]="formControls.workHourStart"
                      pattern="((0|1)\d|2[0-4]):[0-5][0-9]"
                      required
                    />
                  </mat-form-field>
                </div>
                <div>
                  <mat-form-field class="flex flex-row flex-grow w-52" appearance="fill">
                    <mat-label i18n>Ordinarie arbetstid slutar</mat-label>
                    <input
                      matInput
                      type="time"
                      [formControl]="formControls.workHourEnd"
                      pattern="((0|1)\d|2[0-4]):[0-5][0-9]"
                      required
                    />
                  </mat-form-field>
                </div>
              </div>
              <div class="text-sm max-w-md" *ngIf="formControls.probationary.value" i18n>
                Ordinarie arbetstid är de arbetstider som den anställde ska förvänta sig att behöva vara tillgänglig för
                arbete om ingenting annat överenskommits. Ni kan till exempel ha ordinarie arbetstid från 08.00 - 17.00
                med 1 timmes lunch, men komma överens om att den anställde själv fördelar sin arbetstid om ingenting
                annat kommunicerats från arbetsgivaren.
              </div>
            </div>
          </div>
        </sut-step>

        <sut-step label="Rollen" i18n-label [stepControl]="formGroups.role">
          <div class="p-4 bg-white flex flex-col gap-10">
            <div class="flex flex-row gap-10">
              <mat-form-field
                class="w-52"
                appearance="fill"
                *ngIf="[Language.Swedish, Language.Both].includes(formControls.language.value)"
              >
                <mat-label i18n>Position/Titel (svenska)</mat-label>
                <input matInput [formControl]="formControls.position" required />
                <mat-error *ngIf="formControls.position.hasError('required')" i18n>Måste fyllas i</mat-error>
                <mat-hint><span i18n>Exempel</span>: Office Cat</mat-hint>
              </mat-form-field>

              <mat-form-field
                class="w-52"
                appearance="fill"
                *ngIf="[Language.English, Language.Both].includes(formControls.language.value)"
              >
                <mat-label i18n>Position/Titel (engelska)</mat-label>
                <input matInput [formControl]="formControls.positionSl" required />
                <mat-error *ngIf="formControls.positionSl.hasError('required')" i18n>Måste fyllas i</mat-error>
                <mat-hint><span i18n>Exempel</span>: Office Cat</mat-hint>
              </mat-form-field>
            </div>

            <mat-form-field class="w-52" appearance="fill">
              <mat-label i18n>Placeringsort</mat-label>
              <input matInput [formControl]="formControls.location" required />
              <mat-error *ngIf="formControls.location.hasError('required')" i18n>Måste fyllas i</mat-error>
              <mat-hint><span i18n>Exempel</span>: Silicon Valley</mat-hint>
            </mat-form-field>

            <div class="flex flex-col gap-6" *ngIf="data.docKind !== DocKind.ManagingDirector">
              <ng-container *ngIf="[Language.Swedish, Language.Both].includes(formControls.language.value)">
                <mat-form-field appearance="fill">
                  <mat-label i18n>Arbetsuppgifter (svenska) Den Anställde skall</mat-label>
                  <input matInput [formControl]="formControls.duties" />
                  <mat-hint
                    ><span i18n>Exempel</span>: Den Anställde skall utföra arbetsuppgifter som ges av Bolaget från tid
                    till annan, enligt Bolagets instruktioner.</mat-hint
                  >
                </mat-form-field>
                <div class="text-sm w-96" i18n>Om detta fält lämnas tomt kommer exempeltexten fyllas i.</div>
              </ng-container>

              <ng-container *ngIf="[Language.English, Language.Both].includes(formControls.language.value)">
                <mat-form-field appearance="fill">
                  <mat-label i18n>Arbetsuppgifter (engelska) The employee shall</mat-label>
                  <input matInput [formControl]="formControls.dutiesSl" />
                  <mat-hint
                    ><span i18n>Exempel</span>: The Employee shall perform the duties set forth by the Company from time
                    to time, according to Company guidelines and instructions.</mat-hint
                  >
                </mat-form-field>
                <div class="text-sm w-96" i18n>Om detta fält lämnas tomt kommer exempeltexten fyllas i.</div>
              </ng-container>
            </div>
          </div>
        </sut-step>

        <sut-step label="Lön" i18n-label [stepControl]="formGroups.salary">
          <div class="p-4 bg-white flex flex-col gap-3">
            <mat-form-field class="flex flex-row flex-grow w-60" appearance="fill">
              <mat-label>
                <ng-container *ngIf="formControls.kind.value !== EmploymentKind.Hourly; else hourly">
                  <span i18n>Månadslön</span>
                </ng-container>
                <ng-template #hourly><span i18n>Timlön</span></ng-template>
              </mat-label>
              <input matInput [formControl]="formControls.salary" localizedNumericInput [minNumber]="0" required />
              <span matSuffix>kr</span>
              <mat-error *ngIf="formControls.salary.hasError('required')" i18n>Måste fyllas i</mat-error>
            </mat-form-field>

            <div class="text-sm w-96" *ngIf="formControls.partTime.value" i18n>
              Ange den månadslön som är tänkt att betalas ut för den arbetstid som angetts. Exempel: Vid 20h/veckan,
              ange 10 000 SEK om lön för 40h/vecka hade varit 20 000 SEK.
            </div>

            <div class="text-sm w-96" *ngIf="formControls.kind.value !== EmploymentKind.Hourly; else hourlyHint" i18n>
              Enligt avtalet utbetalas ingen ersättning för övertid. Upprätta separat avtal för att reglera eventuell
              övertidserstättning.
            </div>
            <ng-template #hourlyHint
              ><div class="text-sm w-96" i18n>
                Enligt avtalet är timlönen angiven inklusive semesterersättning.
              </div></ng-template
            >
          </div>
        </sut-step>

        <sut-step
          label="Semester"
          i18n-label
          [stepControl]="formGroups.vacation"
          *ngIf="formControls.kind.value !== EmploymentKind.Hourly"
        >
          <div class="p-4 bg-white flex flex-col gap-3">
            <mat-form-field class="flex flex-row flex-grow w-60" appearance="fill">
              <mat-label i18n>Semesterår</mat-label>
              <mat-select [formControl]="formControls.vacationStartDate">
                <mat-option *ngFor="let r of vacationRange$ | async" [value]="r.i">
                  {{ r.start | dateTimeToFormat: 'dd MMMM' }} - {{ r.end | dateTimeToFormat: 'dd MMMM' }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="flex flex-row flex-grow w-60" appearance="fill">
              <mat-label i18n>Semesterdagar per år</mat-label>
              <input matInput [formControl]="formControls.vacationDays" [integerOnly]="true" />
              <span matSuffix i18n>dagar</span>
            </mat-form-field>

            <mat-form-field class="flex flex-row flex-grow w-96" appearance="fill">
              <mat-label i18n>Intjänande av semesterdagar</mat-label>
              <mat-select [formControl]="formControls.vacationKind" required>
                <mat-option [value]="0" i18n>Intjänandeår sammanfaller med semesterår</mat-option>
                <mat-option [value]="1" i18n>Intjänandeår är år föregående semesteråret</mat-option>
              </mat-select>
            </mat-form-field>

            <ng-container *ngIf="formControls.vacationKind.value === 1">
              <mat-form-field class="flex flex-row flex-grow w-60" appearance="fill">
                <mat-label i18n>Förskottssemester</mat-label>
                <mat-select [formControl]="formControls.vacationAdvance" required>
                  <mat-option [value]="0" i18n>Ingen förskottssemester</mat-option>
                  <mat-option [value]="10">10 <span i18n>dagar</span></mat-option>
                  <mat-option [value]="15">15 <span i18n>dagar</span></mat-option>
                  <!-- I know it's weird to suddenly use a bool here, but it's the only way it makes sense since we have to use formControls.vacationDays then -->
                  <mat-option [value]="true"
                    >Full ({{ formControls.vacationDays.value }} <span i18n>dagar</span>)</mat-option
                  >
                </mat-select>
              </mat-form-field>

              <div class="flex flex-col" *ngIf="formControls.vacationAdvance.value > 0">
                <mat-checkbox [formControl]="formControls.vacationClawBack" color="primary" i18n
                  >Förskottssemester kan återbetalas</mat-checkbox
                >
                <div class="text-sm w-96" i18n>
                  Om den anställde slutar på egen begäran inom fem år skall förskottssemestern återbetalas med
                  slutlönen.
                </div>
              </div>
            </ng-container>
          </div>
        </sut-step>

        <sut-step label="Förmåner" i18n-label [hasError]="benefitsHasErrors$ | async" [errorMessage]="">
          <div class="p-4 bg-white flex flex-col gap-3">
            <div class="flex flex-col">
              <div>
                <mat-checkbox [formControl]="formControls.preventiveCare" color="primary" i18n
                  >Friskvårdsbidrag</mat-checkbox
                >
                <div class="text-sm" i18n>
                  Friskvårdsbidrag anges enligt företagets policy i avtalet. Olika nivåer inom samma företag är inte
                  tillåtet.
                </div>
              </div>
              <div>
                <mat-checkbox [formControl]="formControls.pension" color="primary" i18n>Tjänstepension</mat-checkbox>
                <div class="text-sm" i18n>Tjänstepension anges enligt företagets policy i avtalet.</div>
              </div>
              <mat-checkbox [formControl]="formControls.occupationalInjuryInsurance" color="primary" i18n
                >Trygghestförsäkring vid arbetsskada (TFA)</mat-checkbox
              >
              <mat-checkbox [formControl]="formControls.serviceGroupLifeInsurance" color="primary" i18n
                >Tjänstegrupplivsförsäkring (TGL)</mat-checkbox
              >
              <mat-checkbox [formControl]="formControls.healthInsurance" color="primary" i18n
                >Sjukförsäkring</mat-checkbox
              >
              <mat-checkbox [formControl]="formControls.healthCareInsurance" color="primary" i18n
                >Sjukvårdsförsäkring</mat-checkbox
              >
              <mat-checkbox [formControl]="formControls.mobilePhonePlan" color="primary" i18n
                >Mobiltelefonabonnemang</mat-checkbox
              >
            </div>
            <div class="flex flex-col gap-3">
              <mat-divider />
              <div class="pt-2">
                <button mat-stroked-button type="button" color="primary" (click)="addInsurance()" i18n>
                  Lägg till förmån
                </button>
              </div>
              <mat-list class="overflow-auto max-h-40">
                <mat-list-item *ngFor="let insurance of insurances$ | async; index as idx">
                  <div matListItemTitle *ngIf="[Language.Swedish, Language.Both].includes(formControls.language.value)">
                    <span *ngIf="insurance.primary_lang">{{ insurance.primary_lang }}</span>
                    <mat-error *ngIf="!insurance.primary_lang" i18n>Svensk text saknas</mat-error>
                  </div>
                  <div matListItemTitle *ngIf="[Language.English, Language.Both].includes(formControls.language.value)">
                    <span *ngIf="insurance.secondary_lang">{{ insurance.secondary_lang }}</span>
                    <mat-error *ngIf="!insurance.secondary_lang" i18n>Engelsk text saknas</mat-error>
                  </div>
                  <div matListItemMeta>
                    <button type="button" mat-icon-button color="primary" (click)="editInsurance(idx)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button type="button" mat-icon-button color="warn" (click)="rmInsurance(idx)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                  <mat-divider />
                </mat-list-item>
              </mat-list>
            </div>
          </div>
        </sut-step>

        <sut-step label="Åtaganden" i18n-label [stepControl]="formGroups.confidentiality">
          <div class="p-4 bg-white flex flex-col gap-20">
            <mat-form-field class="flex flex-row flex-grow w-64" appearance="fill">
              <mat-label i18n>Vite vid brott mot konfidentialitetsavtalet</mat-label>
              <input matInput [formControl]="formControls.penalty" [integerOnly]="true" required />
              <span matSuffix>kr</span>
              <mat-hint i18n>Standard: 50 000 under konfidentialitetsbrott</mat-hint>
            </mat-form-field>

            <div class="flex flex-col gap-3">
              <mat-form-field class="flex flex-row flex-grow w-64" appearance="fill">
                <mat-label i18n>Förbud mot att rekrytera kollegor</mat-label>
                <input
                  matInput
                  [formControl]="formControls.nonSolicitationPeriod"
                  [integerOnly]="true"
                  [minNumber]="0"
                  [maxNumber]="18"
                  required
                />
                <mat-error *ngIf="formControls.nonSolicitationPeriod.hasError('minNumber')" i18n
                  >Får inte vara negativt</mat-error
                >
                <mat-error *ngIf="formControls.nonSolicitationPeriod.hasError('maxNumber')" i18n
                  >Får högst vara 18 månader</mat-error
                >
                <span matSuffix i18n>månader</span>
              </mat-form-field>
              <div class="flex flex-row flex-grow gap-2 w-96">
                <div class="self-center">{{ sliderNonSolicitPeriod.min }}</div>
                <mat-slider
                  #sliderNonSolicitPeriod
                  class="flex flex-row w-96"
                  color="primary"
                  thumbLabel
                  step="1"
                  min="0"
                  max="18"
                  aria-label="units"
                  ><input matSliderThumb [formControl]="formControls.nonSolicitationPeriod"
                /></mat-slider>
                <div class="self-center">{{ sliderNonSolicitPeriod.max }}</div>
              </div>
            </div>
          </div>
        </sut-step>

        <sut-step label="Signatur" i18n-label [stepControl]="formGroups.signatory" #lastStep>
          <div class="flex flex-col p-4 bg-white">
            <div>
              <mat-form-field style="min-width: 350px" appearance="fill">
                <mat-label i18n>Vem skriver under för bolaget?</mat-label>
                <app-object-input [formControl]="formControls.companySignatory" required />
                <button mat-button type="button" color="primary" matSuffix (click)="selectSignatoryOne()">
                  <span *ngIf="formControls.companySignatory.value" i18n>BYT PERSON</span>
                  <span *ngIf="!formControls.companySignatory.value" i18n>VÄLJ PERSON</span>
                </button>
                <mat-error *ngIf="formControls.companySignatory.hasError('required')" i18n>Måste väljas</mat-error>
              </mat-form-field>
            </div>
          </div>
        </sut-step>
      </sut-stepper>
    </div>

    <div class="dialog-actions">
      <button type="button" class="btn-secondary" mat-dialog-close i18n>Avbryt</button>
      <button *ngIf="form.valid && stepper.selected === lastStep; else continue" class="btn" type="submit" i18n>
        Skapa dokument
      </button>
      <ng-template #continue>
        <button type="button" class="btn" (click)="stepper.next()" i18n>Fortsätt</button>
      </ng-template>
    </div>
  </div>
</form>
<app-add-identity-wrapper *ngIf="open()" [openSignal]="open" [settings]="settings()" [companyId]="companyId()" />
